import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    color: '#fff',
    width: '42px',
    minWidth: '42px',
    height: '42px',
    fontFamily: ['FuturaStdBold', 'sans-serif'].join(','),
    fontSize: '18px',
    margin: '0 8px',
    borderRadius: '5px',
    fontWeight: 400,
    padding: '5px',
    border: 'none',
    outline: 'none',
    '&:active': {
      backgroundColor: '#fff',
      color: theme.palette.primary.main,
      //animation: `$background .5s ease-in-out`,
    },
  },
  /* '@keyframes background': {
    '0%': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    },
    '10%': {
      backgroundColor: '#fff',
      color: theme.palette.primary.main,
    },
    '90%': {
      backgroundColor: '#fff',
      color: theme.palette.primary.main,
    },
    '100%': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    },
  }, */
}));

export default useStyles;
